import React, { useState } from "react";
import Select from 'react-select';
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { updateStudent } from "../../../../redux/actions/student";
import { searchSchool } from "../../../../redux/actions/common";
import { isEmptyObject } from "../../../../helper";
import "./style.css";

const ManagementModal = ({ data, show, handleClose, setReload }) => {

  const dispatch = useDispatch();

  const filters = useSelector(state => state.dashboard.filters?.filters)
  const classList = useSelector(state => state.student.classList);
  const sectionList = useSelector(state => state.student.sectionList);

  const [formData, setFormData] = useState(data);
  const [schools, setSchools] = useState();

  const handleInputChange = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  const handleFormSubmit = () => {
    const payload = { ...formData }
    payload["schoolId"] = payload?.schoolId?.value ?? formData?.schoolId;
    dispatch(updateStudent(payload, () => {
      handleClose();
      setReload(Math.random());
    }))
  }

  const schoolChangeHandler = (e) => {
    const { value } = e.target;
    if (value.length >= 3) {
      dispatch(searchSchool(value, data => {
        let schoolList = data?.map(item => ({
          value: item.id,
          label: item.displayName,
        }))
        schoolList.sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })
        setSchools(schoolList);
      }))
    } else {
      setSchools();
    }
  }

  const handleChange = (value, name) => {
    setFormData({ ...formData, [name]: value })
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Edit details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-lg-6">
            <label htmlFor="name" className="form-label fw-semibold">Name</label>
            <input type="text" name="name" value={formData?.name} onChange={handleInputChange} className="form-control edit-form-input" placeholder="Student name" />
          </div>
          <div className="col-lg-6" onKeyUp={schoolChangeHandler}>
            <label htmlFor="school" className="form-label fw-semibold">School</label>
            <Select
              name="schoolId"
              placeholder={formData?.schoolName ?? 'Please select school'}
              value={formData?.schoolId}
              onChange={e => handleChange(e, "schoolId")}
              options={schools}
              isSearchable={true}
            />
          </div>
          {!isEmptyObject(filters?.Class) &&
            <div className="col-lg-6 mt-3">
              <label htmlFor="class" className="form-label fw-semibold">Class</label>
              <select className="form-select edit-form-input" name="classId" value={formData?.classId} onChange={handleInputChange}>
                <option disabled value="">Select</option>
                {classList?.map((item, key) => <option key={key} value={item?.id}>{item?.name}</option>)}
              </select>
            </div>
          }
          {!isEmptyObject(filters?.Section) &&
            <div className="col-lg-6 mt-3">
              <label htmlFor="section" className="form-label fw-semibold">Section</label>
              <select className="form-select edit-form-input" name="sectionId" value={formData?.sectionId} onChange={handleInputChange}>
                <option disabled value="">Select</option>
                {sectionList?.map((item, key) => <option key={key} value={item?.id}>{item?.name}</option>)}
              </select>
            </div>
          }
          <div className="col-lg-6 mt-3">
            <label className="form-label fw-semibold">Roll No</label>
            <input type="number" name="rollNumber" value={formData?.rollNumber} onChange={handleInputChange} className="form-control edit-form-input" placeholder="Roll number" />
          </div>
          <div className="col-lg-6 mt-3">
            <label className="form-label fw-semibold">Status</label>
            <select className="form-select edit-form-input" name="requestedStatus" value={formData?.requestedStatus} onChange={handleInputChange}>
              <option disabled value="">Select</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>
          </div>
        </div>
      </Modal.Body>
      <div className="row bottom-btn mb-4 mt-3 justify-content-between mx-0 px-4">
        <div className="col-lg-6">
          <div className="d-grid gap-2">
            <button className="btn btns btn-left" type="button" onClick={handleClose}>Cancel</button>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="d-grid gap-2">
            <button className="btn btns btn-right" type="button" onClick={handleFormSubmit}>Save</button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ManagementModal;